const label4BEMapper = (label?: string): string => {
  switch (label) {
    case 'Organization':
      return 'organizationName';
    case 'Status':
      return 'status';
    case 'Start Date':
      return 'startDate';
    case 'End Date':
      return 'endDate';
    case 'Total':
      return 'total';
    case 'Used':
      return 'used';
    case 'Designation':
      return 'designation';
    case 'Appointment Type':
      return 'appointmentType';
    case 'Name':
      return 'search';
    case 'Practice Name':
      return 'search';
    case 'Type':
      return 'type';
    case 'Is Read':
      return 'isRead';
    case 'Channel':
      return 'channel';
    case 'Action':
      return 'action';
    case 'Text':
      return 'search';
    case 'Created At':
      return 'createdAt';
    case 'Title':
      return 'title';
    case 'Statuses':
      return 'status';
    case 'Screener Date & Time':
      return 'createdAt';
    case 'Combined Score':
      return 'totalScore';
    default:
      return '';
  }
};

export { label4BEMapper };
